import {
  CREATE_CATEGORY,
  CREATE_CATEGORY_FAILED,
  CREATE_CATEGORY_SUCCESS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_FAILED,
  DELETE_CATEGORY_SUCCESS,
  EDIT_CATEGORY,
  EDIT_CATEGORY_FAILED,
  EDIT_CATEGORY_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_FAILED,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORY,
  GET_CATEGORY_FAILED,
  GET_CATEGORY_SUCCESS,
  HIDE_CATEGORY_ERROR_MODAL,
  HIDE_DELETE_CATEGORY_MODAL,
  HIDE_EDIT_CATEGORY_MODAL,
  OPEN_CATEGORY_ERROR_MODAL,
  OPEN_DELETE_CATEGORY_MODAL,
  OPEN_EDIT_CATEGORY_MODAL,
  RESET_CATEGORY,
  UPDATE_CATEGORY_ORDER,
  UPDATE_CATEGORY_ORDER_FAILED,
  UPDATE_CATEGORY_ORDER_SUCCESS,
  UPDATE_MULTIPLE_CATEGORIES_ORDER,
  UPDATE_MULTIPLE_CATEGORIES_ORDER_FAILED,
  UPDATE_MULTIPLE_CATEGORIES_ORDER_SUCCESS,
} from "./actionTypes"

export const getCategories = params => ({
  type: GET_CATEGORIES,
  payload: { params },
})

export const getCategoriesSuccess = categories => ({
  type: GET_CATEGORIES_SUCCESS,
  payload: categories,
})

export const getCategoriesFailed = error => ({
  type: GET_CATEGORIES_FAILED,
  payload: error,
})

export const updateCategoryOrder = params => ({
  type: UPDATE_CATEGORY_ORDER,
  payload: { params },
})

export const updateCategoryOrderSuccess = params => ({
  type: UPDATE_CATEGORY_ORDER_SUCCESS,
  payload: params,
})

export const updateCategoryOrderFailed = error => ({
  type: UPDATE_CATEGORY_ORDER_FAILED,
  payload: error,
})

export const openEditCategoryModal = () => ({
  type: OPEN_EDIT_CATEGORY_MODAL,
  payload: {},
})

export const hideEditCategoryModal = () => ({
  type: HIDE_EDIT_CATEGORY_MODAL,
  payload: {},
})

export const editCategory = (categoryId, data) => ({
  type: EDIT_CATEGORY,
  payload: { categoryId, data },
})

export const editCategorySuccess = (categoryId, data) => ({
  type: EDIT_CATEGORY_SUCCESS,
  payload: { categoryId, data },
})

export const editCategoryFailed = error => ({
  type: EDIT_CATEGORY_FAILED,
  payload: error,
})

export const openDeleteCategoryModal = () => ({
  type: OPEN_DELETE_CATEGORY_MODAL,
  payload: {},
})

export const hideDeleteCategoryModal = () => ({
  type: HIDE_DELETE_CATEGORY_MODAL,
  payload: {},
})

export const deleteCategory = params => ({
  type: DELETE_CATEGORY,
  payload: params,
})

export const deleteCategorySuccess = response => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: response,
})

export const deleteCategoryFailed = error => ({
  type: DELETE_CATEGORY_FAILED,
  payload: error,
})

export const createCategory = params => ({
  type: CREATE_CATEGORY,
  payload: params,
})

export const createCategorySuccess = response => ({
  type: CREATE_CATEGORY_SUCCESS,
  payload: response,
})

export const createCategoryFailed = error => ({
  type: CREATE_CATEGORY_FAILED,
  payload: error,
})

export const openCategoryErrorModal = () => ({
  type: OPEN_CATEGORY_ERROR_MODAL,
  payload: {},
})

export const hideCategoryErrorModal = () => ({
  type: HIDE_CATEGORY_ERROR_MODAL,
  payload: {},
})

export const getCategory = params => ({
  type: GET_CATEGORY,
  payload: params,
})

export const getCategorySuccess = response => ({
  type: GET_CATEGORY_SUCCESS,
  payload: response,
})

export const getCategoryFailed = error => ({
  type: GET_CATEGORY_FAILED,
  payload: error,
})

export const resetCategory = () => ({
  type: RESET_CATEGORY,
  payload: {},
})

export const updateMultipleCategoriesOrder = params => ({
  type: UPDATE_MULTIPLE_CATEGORIES_ORDER,
  payload: params,
})

export const updateMultipleCategoriesOrderSuccess = response => ({
  type: UPDATE_MULTIPLE_CATEGORIES_ORDER_SUCCESS,
  payload: response,
})

export const updateMultipleCategoriesOrderFailed = error => ({
  type: UPDATE_MULTIPLE_CATEGORIES_ORDER_FAILED,
  payload: error,
})
